import { render, staticRenderFns } from "./EditGhazal.vue?vue&type=template&id=230b8c73&"
import script from "./EditGhazal.vue?vue&type=script&lang=js&"
export * from "./EditGhazal.vue?vue&type=script&lang=js&"
import style0 from "./EditGhazal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports